import "./AboutHydroRoof.module.css";
import Header from "@/reusable_sections/Header";
import HydroRoof from "./sections/HydroRoof";
import Benefits from "./sections/Benefits";
import Guarantee from "./sections/Guarantee";
import Footer from "@/reusable_sections/Footer";
export default function AboutHydroRoofPage() {
  return <div>
      <Header />
      <HydroRoof />
      <Benefits />
      <Guarantee />
      <Footer />
    </div>;
}